import { render, staticRenderFns } from "./LeadSettings.vue?vue&type=template&id=6cb72a1f&"
import script from "./LeadSettings.vue?vue&type=script&lang=js&"
export * from "./LeadSettings.vue?vue&type=script&lang=js&"
import style0 from "./LeadSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports